import { Box, LinearProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';

const useStyes = makeStyles()(theme => ({
  progressBar: {
    backgroundColor: '#CC0000',
    height: '6px',
    border: '0px', 
    borderRadius: '6px',
    '& .MuiLinearProgress-bar': {
      borderRight: '2px solid #f5f5f5',
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: `${theme.palette.framework.alertColors.success} !important`,
    },
  },
  progressBarCompleted: {
    backgroundColor: '#CC0000',
    height: '6px',
    border: '0px', 
    borderRadius: '6px',
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor:  `${theme.palette.framework.alertColors.success} !important`,
    },
  }
}));

interface LinearProgressBarProps {
  value: number;
  filledItemscount: number;
  totalItems: number;
  size?: string;
}

export const LinearProgressBar = (props: LinearProgressBarProps) => {
  const { classes } = useStyes();

  return (
    <>
      <Box style={{ display: 'flex', alignItems: 'center' }}>
        <Box style={{ width: '100%' }}>
          <LinearProgress
            variant="determinate"
            className={props.value === 100 ? classes.progressBarCompleted : classes.progressBar}
            style={props.size && { height: props.size, borderRadius: props.size}}
            {...props}
          />
        </Box>
      </Box>
    </>
  );
};